import emailValidator from 'helpers/email_validator';

import {
  containsNumber,
  containsUpperCaseLetter,
  containsLowerCaseLetter,
  hasValidLength
} from 'helpers/password_validator';

angular.module('public').controller('SignUpCtrl', ["$scope", "vcRecaptchaService", function($scope, vcRecaptchaService) {
  var getRecaptchaToken, ref, ref1, ref2, ref3, validate, validateWithBlur;
  $scope.params = {};
  $scope.data = {
    first_name: (ref = angular.element('#user_first_name')[0]) != null ? ref.value : void 0,
    last_name: (ref1 = angular.element('#user_last_name')[0]) != null ? ref1.value : void 0,
    email: (ref2 = angular.element('#user_email')[0]) != null ? ref2.value : void 0
  };
  $scope.errors = {};
  $scope.blurEvents = {};
  $scope.recaptchaKey = (ref3 = window.DATA) != null ? ref3.recaptchaKey : void 0;
  $scope.containsNumber = function() {
    return containsNumber($scope.data.password);
  };
  $scope.containsUpperCaseLetter = function() {
    return containsUpperCaseLetter($scope.data.password);
  };
  $scope.containsLowerCaseLetter = function() {
    return containsLowerCaseLetter($scope.data.password);
  };
  $scope.hasValidLength = function() {
    return hasValidLength($scope.data.password);
  };
  $scope.enablePasswordValidation = function() {
    return $scope.params.passwordRequired = true;
  };
  $scope.onRecaptchaSubmitted = function(response) {
    $scope.recaptchaToken = response;
    return document.getElementById('submit-button').click();
  };
  $scope.onRecaptchaCreated = function(id) {
    return $scope.recaptchaWidgetId = id;
  };
  $scope.togglePassword = function() {
    return $scope.params.passwordVisible = !$scope.params.passwordVisible;
  };
  validate = function(field, form) {
    var value;
    value = field === 'email' && form ? form['user[email]'].$viewValue : $scope.data[field] || '';
    if (!value || !value.trim()) {
      $scope.errors[field] = ['This field is required'];
      return;
    }
    if (field === 'email' && !emailValidator(value)) {
      $scope.errors[field] = ['This field is invalid'];
      return;
    }
    return $scope.errors[field] = void 0;
  };
  validateWithBlur = function(field, form) {
    $scope.blurEvents[field] = true;
    return validate(field, form);
  };
  $scope.onFieldChange = function(field, form) {
    if ($scope.blurEvents[field]) {
      return validate(field, form);
    }
  };
  $scope.onFieldBlur = function(field) {
    return $scope.blurEvents[field] = true;
  };
  $scope.onFieldFocus = function(field) {
    if (field === 'password') {
      return $scope.passwordFieldFocused = true;
    }
  };
  getRecaptchaToken = function() {
    if ($scope.recaptchaLoading) {
      return;
    }
    $scope.recaptchaLoading = true;
    return vcRecaptchaService.execute($scope.recaptchaWidgetId);
  };
  $scope.back = function() {
    return window.history.back();
  };
  return $scope.onFormSubmit = function(event) {
    validateWithBlur('first_name');
    validateWithBlur('last_name');
    validateWithBlur('email');
    if ($scope.params.passwordRequired) {
      validateWithBlur('password');
    }
    if (_.compact(_.values($scope.errors)).length) {
      event.preventDefault();
      return;
    }
    if ($scope.recaptchaKey && !$scope.recaptchaToken) {
      getRecaptchaToken();
      return event.preventDefault();
    }
  };
}]);
